/**
 * Kam se UI „obrátí“ MCP voláním, aniž by opustilo aktuální veřejné UI.
 * null = host (ten nod, jehož stránku máš otevřenou).
 *
 * Odloženo: napojení v mcpCall je vypnuté — přepnutí jen target_node
 * shodilo levé menu (neúplné přihlášení). Helpery zůstávají pro později.
 */
const KEY = 'acm_call_target';

let current: string | null = readStored();
const listeners = new Set<() => void>();

function readStored(): string | null {
  try {
    const v = sessionStorage.getItem(KEY);
    return v && v.trim() ? v.trim() : null;
  } catch {
    return null;
  }
}

export function getCallTarget(): string | null {
  return current;
}

export function setCallTarget(id: string | null): void {
  const next = id && id.trim() ? id.trim() : null;
  if (next === current) return;
  current = next;
  try {
    if (next) sessionStorage.setItem(KEY, next);
    else sessionStorage.removeItem(KEY);
  } catch {
    /* private mode */
  }
  for (const listener of listeners) listener();
}

export function subscribeCallTarget(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export type ApplyCallTargetOpts = {
  /** Seznam nodů / identita hosta — nechat na tomhle UI uzlu. */
  hostLocal?: boolean;
  /** Test hook; když chybí, bere se session target. */
  target?: string | null;
};

export function applyCallTarget(
  args: Record<string, unknown>,
  opts: ApplyCallTargetOpts = {},
): Record<string, unknown> {
  if (opts.hostLocal) return args;
  if (Object.prototype.hasOwnProperty.call(args, 'target_node')) return args;
  const target = Object.prototype.hasOwnProperty.call(opts, 'target')
    ? opts.target
    : getCallTarget();
  if (!target) return args;
  return { ...args, target_node: target };
}
